
import "./components/generalLoader"
import './components/Gallery'
import './components/GalleryOnlyMobile'
import './components/clubComponentMedia'
import './components/clubDatalayer'
import './components/MomentQuestions'
import './components/ProductIntrofeature'
import './pages/NodeProductLanding'
import './components/BlockWeeksblock'
import './components/PlayClubEmbed'
import './utils/utils'
import "./pages/granColombiaScratch"
import './pages/copasLandingPage'
import './pages/meals/loginMeals'
import './pages/meals/datalayers'
import './pages/meals/emailRecoveryPassword'
import './pages/meals/resetPassword'
import './pages/meals/configMeals' // Mantener de ultimo
// import './pages/promoLandingPage'

window.$ = window.jQuery
